import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "../config/cookie";
import { useNavigate } from "react-router-dom";
import { handleInstantPubnubPublishMessage, handleInstantPubnubPublishThreadMessage, handleUpdateGroupSorting, handleUpdateMsgToDb, requestGetAllAcountLevelMember, requestallmemberswithgroups, requestgroupMemberDetails, handleFetchConversation, handleUpdateExistingMessage, handleReadAllMsg, handleSyncStarMsgData, handleDeleteMsgFromDb, requestGetGroupRecipient, requestUpdateFromSignalGroupRecipient, updateGroupArchiveKeyInDb } from "../appStore/actions/ArkchatGroup/action";
import { getProfile } from "../appStore/actions/profile/action";
import { getAllPendingInvitation, switchAccount } from "../appStore/actions/subscriber/action";
import { getAlltopic } from "../appStore/actions/topics/action";
import { subscribeToForegroundMessages } from "../config/firebase.config";
import { jwtDecode } from "jwt-decode";
import { getRefreshToken } from "../appStore/actions/auth/signup/action";
import { handleLogout } from "../appStore/actions/auth/login/loginaction";
import { getAllNotification } from "../appStore/actions/notification/action";
import { handlePubnubSignal } from "../page/chat/HandlePubnubEvent/pubnubSignal";
import { handleAppSelectedTopic, handleScrollToBottom, handleSwitchAccountRefresh, handleThreadScrollToBottom, handleTogglePunbunTokenUpdateState, saveSelectedAppGroupData } from "../appStore/actions/AppState/action";
import RealtimeClient from "../realtime/RealtimeClient";
import { subscriptionChannels } from "../realtime/channels";
import { allWorkspacesSelector } from "../utils/workspaceView";
import { resendAllPending } from "../realtime/outbox";
import { handleFetchMessages } from "../appStore/actions/ArkchatGroup/action";
import { HANDLE_TOAST_OPEN_CLOSE, SHOW_INTERNET_TOAST, SHOW_TOAST_MESSAGE } from "../appStore/actions/global/type";
import { useTranslation } from "react-i18next";
import { PREPEND_TO_APPROVALLIST, UPDATE_EXISTING_APPROVALLIST_DATA, UPDATE_EXISTING_MESSAGE_LIST, UPDATE_EXISTING_TASKLIST_DATA, UPDATE_EXISTING_THREAD_MESSAGE } from "../appStore/actions/ArkchatGroup/type";
import { handleDecryptSingleMessageData } from "../utils/messageEncrypt";
import { MessageType } from "../utils/constant";
import { SHOULD_CALL_PUBNUB_GET_TOKEN, THREAD_LIST_CHANGED, WORK_TRACKING_CHANGED } from "../appStore/actions/AppState/type";
import useAppSelectors from "./useAppSelectors";
import session, { logWrapper } from "../utils/helper";

const useAppState = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [groupname, setGroupname] = useState("");
  const [isTopicOpen, setisTopicOpen] = useState(false);
  const [isAddPeopledarwer, setAddpeopledarwer] = useState(false);
  const [isPricingDrawerOpen, setPricingDrawerOpen] = useState(false);
  const {
    showToast,
    isShowInternetToast,
    currentUserData,
    selectedGroup,
    selectedTopic,
    selectedSubtopic,
    isThreadScrollToBottom,
    groupList,
    archiveGroupList,
    messageList,
    tostmsgData,
    groupRecipientDetails,
    accountLevelPeople,
  } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen"); 
  

  const dispatch = useDispatch();
  const allWorkspaces = useSelector(allWorkspacesSelector);
  const switchAccountRefresh = useSelector(
    (state) => state?.appStateData?.isSwitchAccountRefresh
  );
  const shouldCallPubnubGetToken = useSelector(
    (state) => state?.localAppReducer?.shouldCallPubnubGetToken
  );
  const toggleSetPubTokenState = useSelector(
    (state) => state?.appStateData?.toggleSetPubTokenState
  );
  const token = getCookie("token");
  const isRemember = getCookie("isRemember");
  const [isTokenRefreshed, setIsTokenRefreshed] = useState(
    token && isRemember ? false : true
  );

  const [pubnub, setPubnub] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch({
      type: HANDLE_TOAST_OPEN_CLOSE,
      payload: false,
    });
    dispatch({
      type: SHOW_TOAST_MESSAGE,
      payload: "",
    });
    dispatch({
      type: SHOW_INTERNET_TOAST,
      payload: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      if (navigator.onLine) {
        // The browser is online
        if (isShowInternetToast) {
          dispatch({
            type: HANDLE_TOAST_OPEN_CLOSE,
            payload: true,
          });
          dispatch({
            type: SHOW_TOAST_MESSAGE,
            payload: appContent?.KEY55,
          });
          dispatch({
            type: SHOW_INTERNET_TOAST,
            payload: false,
          });
        }
      } else {
        // The browser is offline
        dispatch({
          type: SHOW_INTERNET_TOAST,
          payload: true,
        });
        dispatch({
          type: HANDLE_TOAST_OPEN_CLOSE,
          payload: true,
        });
        dispatch({
          type: SHOW_TOAST_MESSAGE,
          payload: appContent?.KEY54,
        });
      }
    };

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);
    handleOnlineStatusChange();
    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowInternetToast]);

  useEffect(() => {
    if (currentUserData) {
      // Self-hosted Socket.IO gateway (arkchat-backend-pubnub).
      const realtime = new RealtimeClient({ baseUrl: process.env.REACT_APP_BASE_PATH });
      setPubnub(realtime);
      return () => realtime.destroy();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserData?.id]);

  // Send whatever is still pending (sent offline, or failed) once the
  // connection is back: when the socket (re)connects, and when the browser
  // comes back online (the socket can take ~45 s to notice a dropped network).
  useEffect(() => {
    if (!pubnub) return;
    const resend = () =>
      resendAllPending({ pubnub, dispatch, userId: currentUserData?.id });
    const listener = {
      status: (statusEvent) => {
        if (
          statusEvent.category === "PNConnectedCategory" ||
          statusEvent.category === "PNReconnectedCategory"
        ) {
          resend();
        }
      },
    };
    let onlineTimer;
    const handleOnline = () => {
      clearTimeout(onlineTimer);
      onlineTimer = setTimeout(resend, 1500);
    };
    pubnub.addListener(listener);
    window.addEventListener("online", handleOnline);
    return () => {
      pubnub.removeListener(listener);
      window.removeEventListener("online", handleOnline);
      clearTimeout(onlineTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pubnub]);

  // Recompute the channels whenever either list changes, not only when
  // SHOULD_CALL_PUBNUB_GET_TOKEN is set: the archive list usually loads after
  // the main one, and archived chats were never listened to (their messages
  // only showed after a refresh).
  useEffect(() => {
    if (!currentUserData || !pubnub) return;
    pubnub.unsubscribeAll();
    pubnub.subscribe({
      channels: subscriptionChannels(groupList, archiveGroupList, currentUserData, allWorkspaces),
      withPresence: false,
    });
    if (shouldCallPubnubGetToken) {
      dispatch({
        type: SHOULD_CALL_PUBNUB_GET_TOKEN,
        payload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupList?.length, archiveGroupList?.length, pubnub, shouldCallPubnubGetToken, currentUserData?.activeSubscriber?.id, allWorkspaces, currentUserData?.subscribedTo?.length]);

  useEffect(() => {
    if (currentUserData && pubnub) {
    const messageListener = {
        message: function (messageEvent) {
          logWrapper(messageEvent, "messageEvent");
          if (messageEvent?.message?.type === "signal") {
            const loggedInUserActiveSubsId =
              currentUserData?.activeSubscriber?.id;
            const loggedInUserId = currentUserData?.id;
            const sidList = currentUserData?.subscribedTo;
            handlePubnubSignal({
              allWorkspaces,
              loggedInUserActiveSubsId,
              loggedInUserId,
              sidList,
              messageEvent,
              dispatch,
              requestallmemberswithgroups,
              setisTopicOpen,
              handleCloseAddPeopleDrawer,
              getAlltopic,
              requestgroupMemberDetails,
              requestGetGroupRecipient,
              requestUpdateFromSignalGroupRecipient,
              groupList,
              groupRecipientDetails,
              switchAccount,
              getProfile,
              switchAccountId: currentUserData?.subscribedTo[0]?.id,
              requestGetAllAcountLevelMember,
              setGroupname,
              navigate,
              currentUserData,
              saveSelectedAppGroupData,
              handleAppSelectedTopic,
              selectedGroup,
              handleFetchConversation,
              handleUpdateExistingMessage,
              messageList,
              selectedTopic,
              selectedSubtopic,
              isThreadScreen,
              getAllPendingInvitation,
              handleScrollToBottom,
              handleSwitchAccountRefresh,
              switchAccountRefresh,
              handleSyncStarMsgData,
              handleDeleteMsgFromDb,
              toggleSetPubTokenState,
              handleTogglePunbunTokenUpdateState,
              updateGroupArchiveKeyInDb
            });
          } else {
            let newMessageEvent = handleDecryptSingleMessageData(
              messageEvent.message.content.message
            );
            // A message to everyone comes without its recipient lists
            // (compact). It's to this user: put them in, as the chat service
            // does in the messages it returns (the views look for the
            // viewer's own entry, e.g. for their language).
            if (newMessageEvent?.compact === true && newMessageEvent?.is_all_group_member === true) {
              newMessageEvent = {
                ...newMessageEvent,
                to: [{
                  id: currentUserData?.id,
                  pp: currentUserData?.profileImgUrl,
                  name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
                  target_subscriber_id: currentUserData?.activeSubscriber?.id,
                  languageCode: currentUserData?.languageCode,
                }],
                participants: [currentUserData?.id],
              };
            }
            const eventType = messageEvent.message.content?.type;
            // My own message (from this or another device) is saved as read
            // by me: there's nothing for mark-as-read to do.
            const isOwnMessage =
              String(messageEvent.message.content.message?.from?.id) ===
              String(currentUserData?.id);
            if (eventType === "conversation-message" || eventType === "message-thread") {
              dispatch({
                type: THREAD_LIST_CHANGED,
                payload: { pnId: messageEvent.message.content.message?.pnId },
              });
            }
            // A task/approval was created (also as a subtask or a chained
            // approval) or updated: an open Track Work view re-runs its query.
            const isTaskOrApproval =
              newMessageEvent?.type === MessageType?.Task ||
              newMessageEvent?.type === MessageType?.Approval;
            if (
              eventType === "conversation-update" ||
              (isTaskOrApproval && (eventType === "conversation-message" || eventType === "message-thread"))
            ) {
              dispatch({
                type: WORK_TRACKING_CHANGED,
                payload: { pnId: messageEvent.message.content.message?.pnId },
              });
            }
            // logWrapper(newMessageEvent, "decrypted");
            let message;
            if (messageEvent.message.content?.type === "conversation-message") {
              message = [
                {
                  ...newMessageEvent,
                  publisher: messageEvent?.publisher,
                  timetoken: +messageEvent?.timetoken,
                },
              ];
              if (
                (messageEvent.message.content.message.is_all_group_member === true) || messageEvent.message.content.message.participants?.includes(
                  currentUserData.id
                )
              ) {
                if (
                  !isThreadScreen ||
                  !messageEvent.message.content.message?.thread_id
                ) {
                  dispatch(handleThreadScrollToBottom(null));
                }
                dispatch(handleScrollToBottom(true));

                dispatch(
                  handleUpdateGroupSorting(
                    messageEvent.message.content.message?.pnId,
                    +messageEvent?.timetoken,
                    selectedGroup?.pnId,
                    { from: newMessageEvent?.from, message: newMessageEvent?.message }
                  )
                );
                const readAllmsgBody = {
                  ref_id: messageEvent.message.content.message?.pnId,
                };
                // Task/approval replies (is_main false) go to the open thread
                // when it's showing, otherwise to the main list (which also
                // clears the sender's pending copy). Only one of the two runs,
                // so the reply is never added twice.
                const isReplyForOpenThread =
                  newMessageEvent?.is_main === false &&
                  isThreadScreen &&
                  !!messageEvent.message.content.message?.thread_id;
                if (!isReplyForOpenThread) {
                  dispatch(
                    handleInstantPubnubPublishMessage(
                      message,
                      selectedGroup?.pnId,
                      selectedTopic?.id,
                      messageEvent.message.content.message?.temp_timetoken,
                      selectedSubtopic?.id || ""
                    )
                  );
                } else {
                  //this is for when we update task/approval its reply comes as a conversation-msg
                  dispatch(
                    handleInstantPubnubPublishThreadMessage(
                      message,
                      selectedGroup?.pnId,
                      selectedTopic?.topic_id,
                      messageEvent.message.content.message?.temp_timetoken,
                      false,
                      isThreadScrollToBottom,
                      true
                    )
                  );
                }

                if (
                  !isOwnMessage &&
                  selectedGroup?.pnId ===
                  messageEvent.message.content.message?.pnId
                ) {
                  setTimeout(() => {
                    dispatch(handleReadAllMsg(readAllmsgBody));
                  }, 500);
                }
              }
            } else if (
              messageEvent.message.content?.type === "direct-message"
            ) {
              message = [
                {
                  ...newMessageEvent,
                  publisher: messageEvent?.publisher,
                  timetoken: +messageEvent?.timetoken,
                },
              ];
              if (
                (messageEvent.message.content.message.is_all_group_member === true) || messageEvent.message.content.message.participants?.includes(
                  currentUserData.id
                )
              ) {
                const readAllmsgBody = {
                  ref_id: messageEvent.message.content.message?.pnId,
                };
                dispatch(handleScrollToBottom(true));
                dispatch(
                  handleUpdateGroupSorting(
                    messageEvent.message.content.message?.pnId,
                    +messageEvent?.timetoken,
                    selectedGroup?.pnId,
                    { from: newMessageEvent?.from, message: newMessageEvent?.message }
                  )
                );
                dispatch(
                  handleInstantPubnubPublishMessage(
                    message,
                    selectedGroup?.pnId,
                    selectedTopic?.id,
                    messageEvent.message.content.message?.temp_timetoken,
                    selectedSubtopic?.id || ""
                  )
                );

                if (
                  !isOwnMessage &&
                  selectedGroup?.pnId ===
                  messageEvent.message.content.message?.pnId
                ) {
                  setTimeout(() => {
                    dispatch(handleReadAllMsg(readAllmsgBody));
                  }, 500);
                }
              }
            } else if (
              messageEvent.message.content?.type === "message-thread"
            ) {
              message = [
                {
                  ...newMessageEvent,
                  publisher: messageEvent?.publisher,
                  timetoken: +messageEvent?.timetoken,
                },
              ];
              if (
                (messageEvent.message.content.message.is_all_group_member === true) || messageEvent.message.content.message.participants?.includes(
                  currentUserData.id
                )
              ) {
                const readAllmsgBody = {
                  ref_id: messageEvent.message.content.message?.pnId,
                };
                dispatch(
                  handleUpdateGroupSorting(
                    messageEvent.message.content.message?.pnId,
                    +messageEvent?.timetoken,
                    selectedGroup?.pnId
                  )
                );
                dispatch(
                  handleInstantPubnubPublishThreadMessage(
                    message,
                    selectedGroup?.pnId,
                    selectedTopic?.topic_id,
                    messageEvent.message.content.message?.temp_timetoken,
                    true,
                    isThreadScrollToBottom,
                    true
                  )
                );
                if (message[0]?.type === MessageType?.Approval) {
                  dispatch({
                    type: PREPEND_TO_APPROVALLIST,
                    payload: message[0],
                  });
                }
                if (
                  !isOwnMessage &&
                  selectedGroup?.pnId ===
                  messageEvent.message.content.message?.pnId
                ) {
                  setTimeout(() => {
                    dispatch(handleReadAllMsg(readAllmsgBody));
                  }, 500);
                }
              }
            } else if (
              messageEvent.message.content?.type === "conversation-update"
            ) {
              if (
                (messageEvent.message.content.message.is_all_group_member === true) || messageEvent.message.content.message.participants?.includes(
                  currentUserData.id
                )
              ) {
                message = [
                  {
                    ...newMessageEvent,
                  },
                ];
                if (isThreadScreen) {
                  dispatch({
                    type: UPDATE_EXISTING_THREAD_MESSAGE,
                    payload: message[0],
                  });
                }
                dispatch({
                  type: UPDATE_EXISTING_MESSAGE_LIST,
                  payload: message[0],
                });
                if (message[0]?.type === MessageType?.Task) {
                  dispatch({
                    type: UPDATE_EXISTING_TASKLIST_DATA,
                    payload: message[0],
                  });
                }
                if (message[0]?.type === MessageType?.Approval) {
                  dispatch({
                    type: UPDATE_EXISTING_APPROVALLIST_DATA,
                    payload: message[0],
                  });
                }
                dispatch(handleUpdateMsgToDb(message[0]));
              }
            }
          }
        },
        signal: function (signalData) {},
        status: function (statusEvent) {
          // Sockets don't replay what was missed while disconnected, so re-sync
          // the open conversation (timetoken-based, fetches only what's new).
          if (statusEvent.category === "PNReconnectedCategory") {
            // Chat list previews/unread counts may have changed meanwhile too.
            dispatch(requestallmemberswithgroups({ forceFetch: true }));
            // So are the open group's members (sends use this copy).
            if (selectedGroup?.isGroup && selectedGroup?.id) {
              dispatch(requestgroupMemberDetails({
                group_id: selectedGroup.id,
                target_subscriber_id: currentUserData?.activeSubscriber?.id ?? selectedGroup?.subscriberId,
              }));
            }
          }
          if (statusEvent.category === "PNReconnectedCategory" && selectedGroup?.pnId) {
            dispatch(
              handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id || null, {
                topicId: selectedTopic?.id,
                subtopicId: selectedSubtopic?.id || "",
              })
            );
          }
        },
      };

      pubnub.addListener(messageListener);

      return () => {
        pubnub.removeListener(messageListener);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allWorkspaces,
    selectedGroup,
    selectedTopic,
    selectedSubtopic,
    messageList,
    isThreadScreen,
    isThreadScrollToBottom,
    toggleSetPubTokenState,
    groupRecipientDetails,
  ]);

  const handleCloseAddPeopleDrawer = () => {
    setAddpeopledarwer(false);
  };

  useEffect(() => {
    localStorage.removeItem("isChangeEmail");
  }, []);

  useEffect(() => {
    if (token && isRemember) {
      function isTokenExpired(token) {
        const currentTimestamp = Math.floor(Date.now() / 1000);
        const oneDayInSeconds = 24 * 60 * 60;

        if (token && token.exp) {
          return token.exp - currentTimestamp <= oneDayInSeconds;
        }

        return true;
      }
      try {
        const token = jwtDecode(getCookie("token"));

        const isExpired = isTokenExpired(token);

        if (isExpired) {
          refreshToken();
        } else {
          setIsTokenRefreshed(true);
        }
      } catch (error) {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let timerId;
    if (showToast) {
      timerId = setTimeout(() => {
        dispatch({
          type: HANDLE_TOAST_OPEN_CLOSE,
          payload: false,
        });
      }, 6000);
    }
    return () => {
      clearInterval(timerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tostmsgData]);

  function refreshToken() {
    dispatch(getRefreshToken())
      .then((res) => {
        if (res?.status) {
          setIsTokenRefreshed(true);
        } else {
          setIsTokenRefreshed(true);
        }
      })
      .catch((err) => {
        dispatch(handleLogout());
      });
  }

  const showNotification = (body) => {
    token && dispatch(getAllNotification());

    const notificationOptions = {
      ...body?.notification,
      icon: "/arkchat.jpg",
    };

    const notification = new Notification("Arkchat", notificationOptions);
    notification.onclick = (event) => {
      event.preventDefault();
      window.open("https://platform.arkchat.com/", "_blank");
    };
  };
  // One listener for the app's lifetime: registering it on every render added
  // another each time, so a single push showed several notifications and
  // re-fetched the notification list as many times.
  const showNotificationRef = useRef(showNotification);
  showNotificationRef.current = showNotification;
  useEffect(
    () => subscribeToForegroundMessages((payload) => showNotificationRef.current(payload)),
    []
  );

  return {
    isAddPeopledarwer,
    setAddpeopledarwer,
    setisTopicOpen,
    isTopicOpen,
    isTokenRefreshed,
    setIsTokenRefreshed,
    setGroupname,
    setPricingDrawerOpen,
    isPricingDrawerOpen,
    showToast,

    groupname,
    pubnub,
    dispatch,
    currentUserData,
    groupList,
    accountLevelPeople,
    tostmsgData,
    handleCloseAddPeopleDrawer,
  };
};

export default useAppState;
